import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Spinner } from 'src/app/core/services/spinner.service';
import { ConfirmationDialogComponent } from 'src/app/shared/components/dialog/confirmation-dialog.component';
import { MESSAGE_TOAST } from 'src/app/shared/enums/message-toast-enum';
import { PATH_ROUTING } from 'src/app/shared/enums/routing-enums';
import { GeTagRequest, GE_TAG_FORM_REQUEST_FE_BE_MAPPING_FIELD } from 'src/app/shared/model/ge-tag-request-form.module';
import { GeTagRequestFormService } from 'src/app/shared/service/ge-tag-request-form.service';

export interface STATUS {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-ge-tag-status-update',
  templateUrl: './ge-tag-status-update.component.html',
  styleUrls: ['./ge-tag-status-update.component.scss']
})

export class GeTagStatusUpdateComponent implements OnInit {

  row: any;
  statuses: STATUS[] = [
    {
      value: 'NEW',
      viewValue: 'New'
    },
    {
      value: 'IN PROGRESS',
      viewValue: 'In Progress'
    },
    {
      value: 'PENDING',
      viewValue: 'Pending'
    },
    {
      value: 'COMPLETED',
      viewValue: 'Completed'
    },
    {
      value: 'RETURNED',
      viewValue: 'Returned'
    },
    {
      value: 'REJECTED',
      viewValue: 'Rejected'
    }

  ];
  status: any;
  saveButtonEnabled: boolean = false;
  comment: string;
  @ViewChild('commentDialog') commentDialogTemplate: TemplateRef<any>;
  constructor(
    private router: Router,
    private toastService: ToastrService,
    private dialog: MatDialog,
    private spinner: Spinner,
    private service: GeTagRequestFormService
  ) { }

  ngOnInit() {
    this.rowData();
  }

  userFile(url: string){
    window.open(url, '_blank');
  }

  rowData() {
    this.row = history.state.data;
    if (!this.row) {
      this.router.navigate([PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN + '/' + PATH_ROUTING.PATH_GE_ADMIN_STATUES]);
    } else {
      this.status = this.row.incidentState;
    }
  }

  onSelectionChange(event: any){
      this.openCommentDialog();
  }

  openCommentDialog() {
    let dialogRef = this.dialog.open(this.commentDialogTemplate, {
      height: '300px',
      width: '600px',
      disableClose: (this.status === 'RETURNED' && (this.comment === undefined || this.comment === null || this.comment === '')),
      panelClass: 'update-dialog'
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result !== undefined ){
        this.comment = result;
      }
    });
  }

  onDialogCancel() {
    this.comment = '';
    this.dialog.closeAll();
  }

  onDialogSave() {
    this.dialog.closeAll();
  }

  submit() {
    if(this.status === 'RETURNED' && (this.comment === undefined || this.comment === null || this.comment === '')){
      this.openCommentDialog();
    } else {
      this.openDialog();
    }
    
  }

  openDialog() {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: MESSAGE_TOAST.CONFIRM_TAG_STATUS_UPDATE,
        buttonText: {
          ok: 'Yes',
          cancel: 'No'
        }
      }
    });

    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.spinner.show();
        const body = {
          recordId: this.row.incidentNumber,
          status: this.status,
          approverComments: this.comment ? this.comment : ''
        }
        this.service.updateRecord(body).subscribe((res) => {
          this.spinner.hide();
          this.toastService.success(MESSAGE_TOAST.REQUEST_ACCESS_TICKET_SUCCESS);
          setTimeout(() => {
            this.router.navigate([PATH_ROUTING.PATH_SRM, PATH_ROUTING.PATH_ADMIN, 'ge-tag-id-status']);
          });
        });
      }
    });
  }

}
